import React, { useState } from 'react';

// Libraries
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './styles.scss';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Components
import PageHeader from '../../layouts/page-header/PageHeader';

import aboutImage2 from '../../assets/images/about/02.webp';
import FeatureInfo from '../../component/feature-info';
import DigitalStrategy2 from '../../template/digital-strategy-2';
import { Link } from 'react-router-dom';
import DigitalImage from '../../assets/images/memeber/member.webp';
import DigitalImage1 from '../../assets/images/memeber/6.webp';
import DigitalImage2 from '../../assets/images/memeber/7.webp';
import DigitalImage3 from '../../assets/images/memeber/8.webp';

import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import '../../component/tabs/tabs.scss';
import ContactForm2 from '../../form/contact-form/contactForm2';

const trainingModules = [
  {
    title: 'Visibilité accrue',
    description:
      "En devenant membre, vous avez l'opportunité de faire connaître votre activité, votre marque et vos services auprès des autres membres. Chaque entreprise adhérente bénéficie d'une reconnaissance de son expertise dans son domaine respectif.",
    image: DigitalImage3,
  },
  {
    title: "Accès à l'information",
    description:
      'La chambre vous informe des décisions, projets, et programmes. Cela vous permet de vous préparer et de réagir collectivement aux évolutions du marché. Vous serez ainsi en mesure de prendre des décisions éclairées pour votre entreprise en étant au fait des enjeux et opportunités actuels.',
    image: DigitalImage2,
  },
  {
    title: "Réseautage et relations d'affaires",
    description:
      "Adhérer à notre chambre vous permet de construire des relations d'affaires durables. Profitez de notre réseau pour augmenter la visibilité de votre entreprise et établir des contacts stratégiques.",
    image: DigitalImage1,
  },
];

const InfoBoxTab = [
  {
    title: 'Événements',
    description:
      'Nous organisons différents types d’événements, segmentés par type de rendez-vous, afin de répondre aux divers besoins de nos membres. Ces événements sont des occasions idéales pour échanger, apprendre et développer de nouvelles collaborations.',

    image: 'https://example.com/images/carbon-reduction.jpg',
  },
  {
    title: 'Cohortes et formations',
    description:
      'Des programmes de formation et des cohortes adaptées à la réalité des membres sont proposés pour parfaire vos compétences et favoriser votre développement professionnel et personnel.',
    image: 'https://example.com/images/carbon-reduction.jpg',
  },
  {
    title: 'Projets spéciaux',
    description:
      '   Nous développons des projets variés en fonction des enjeux et besoins spécifiques de nos membres. Ces initiatives sont conçues pour apporter des solutions concrètes et innovantes aux défis que vous rencontrez.',

    image: 'https://example.com/images/carbon-reduction.jpg',
  },
];

function Member() {
  return (
    <>
      <div className="site-content ">
        <PageHeader
          title="Devenir membre de la Chambre de Commerce et d'Industrie Tuniso-Suisse"
          breadCrumbItems={[
            { label: 'Accueil', path: '/' },
            // { label: 'Devenir membre', path: '#', active: true },
          ]}
        />
        <div className="content-wrapper">
          <section className="section-pt">
            <Container>
              <Row className="align-items-center digitalstrategy-content">
                <Col lg={7} className="mb-4 mb-lg-0">
                  <h3 className="mb-4">Pourquoi devenir membre ?</h3>
                  <p className="mb-4">
                    Rejoindre la Chambre de Commerce et d'Industrie
                    Tuniso-Suisse, c'est intégrer une communauté dynamique et
                    diversifiée de professionnels et d'entreprises prestigieuses
                    en Suisse et en Tunisie. Notre chambre est spécialisée et
                    sélective, réunissant les meilleures entreprises et
                    partenaires pour offrir des opportunités uniques à nos
                    membres adhérents.
                  </p>

                  <h3 className="mb-4">La force du réseau : </h3>
                  <p className="mb-4">
                    En intégrant la Chambre de Commerce et d'Industrie
                    Tuniso-Suisse, vous bénéficiez de la force d'un réseau
                    puissant et influent. Nos membres sont des leaders dans
                    leurs domaines, et ensemble, nous créons des synergies
                    bénéfiques pour tous.
                  </p>

                  <Link className="btn btn-light btn-sm mt-3" to="mailto:chambretunisosuisse@gmail.com">
                    En savoir plus
                  </Link>
                </Col>
                <Col lg={5}>
                  <img className="img-fluid" src={DigitalImage} alt="" />
                </Col>
              </Row>
            </Container>
          </section>
          <br/>
          <section className="">
            <Container>
              <Row className="justify-content-center pb-4 pb-md-5">
                <Col lg={10}>
                  <div className="d-md-flex align-items-center">
                    <div className="me-4">
                      <p className="mb-0">Depuis l'Année</p>
                      <h3 className="display-2 fw-bold text-primary mb-0">
                        2011
                      </h3>
                    </div>
                    <div className="me-3">
                      <h2 className="mb-0 ">Les avantages de l'adhésion :</h2>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="align-items-center">
                <Col lg={12}>
                  <TabSection />
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section-ptb">
            <Container>
              <Row className="justify-content-center pb-4 pb-md-5">
                <Col lg={10}>
                  <div className="d-md-flex align-items-center">
                    <div className="me-4">
                      <p className="mb-0">Depuis l'Année</p>
                      <h3 className="display-2 fw-bold text-primary mb-0">
                        2011
                      </h3>
                    </div>
                    <div className="me-3">
                      <h2 className="mb-0">
                        Participez aux activités de la Chambre
                      </h2>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="">
                {InfoBoxTab.map((x) => {
                  return (
                    <Col md={4}>
                      <InfoBox data={x} />
                    </Col>
                  );
                })}
              </Row>
            </Container>
          </section>
          <section>
            <Row>
            <section className="section-pb">
            <Container>
              <Row className="justify-content-lg-around position-relative">
                <Col lg={2} md={2} className="mb-4">
                  <div className="sticky-top custom-sticky">
                    <br/>
                    <h4 className='mb-4 mt-4 primary'>
                    Devenir un membre
                    </h4>
                  </div>
                </Col>
                <Col lg={10} md={10} className="pe-lg-5">
                  <div className="contact-form">
                    <hr/>
                    <h4 className='mb-4 mt-4 primary' style={{textAlign : "center"}}>
                    FORMULAIRE DE COTISATION ANNEE 2025
                    </h4>
                    <p style={{textAlign : "center"}}>Par la présente, nous vous demandons de bien vouloir remplir le présent formulaire et payer la cotisation à la Chambre de commerce et d’industrie Tuniso-Suisse en qualité de membre au titre de l’année 2025</p>
                    <br/>

                    <ContactForm2 />
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

            </Row>
          </section>
        </div>
      </div>
    </>
  );
}

function CareersWithUs(props) {
  console.log(props);

  return (
    <>
      <Row>
        <Col sm={5} className="mb-4 mb-sm-0">
          <img className="img-fluid" src={props.data.image} alt="" />
        </Col>
        <Col
          sm={7}
          className="align-self-start align-self-lg-center ps-md-0 ps-lg-5"
        >
          <h4 className="mb-4">{props.data.title}</h4>
          <p>{props.data.description}</p>
        </Col>
      </Row>
    </>
  );
}

// Libraries

function InfoBox(props) {
  // Title Default H2 Tag with Props
  const { tag: HeadingTag = 'h4' } = props;

  return (
    <div className={`infobox infobox-default mt-4 ${props.extraClass || ''}`}>
      <div className="infobox-top">
        <HeadingTag className="infobox-title">{props.data.title}</HeadingTag>
      </div>
      {props?.data.description && (
        <div className="infobox-description">{props.data.description}</div>
      )}
    </div>
  );
}

const TabsPGSLeft = (props) => {
  return (
    <div className="tabs-main tabs-left">
      <Tab.Container
        id="tabs-default"
        defaultActiveKey={`${props.tabActive || 0}`}
      >
        <Row>
          <Col md={3}>
            <div className="d-flex h-100">
              <Nav
                variant="pills"
                className="flex-column nav-pills w-100 align-self-lg-center"
              >
                {props.tabsTitle.map((item, index) => {
                  return (
                    <Nav.Item key={index}>
                      <Nav.Link eventKey={index}>
                        <span className="data-hover" data-title={item.title}>
                          {item?.icon && <i className={item.icon}></i>}
                          {item.title}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                  );
                })}
              </Nav>
            </div>
          </Col>
          <Col md={9} className="mt-4 mt-md-0">
            <Tab.Content className="ms-md-4">
              {props.tabsContent.map((item, index) => {
                return (
                  <Tab.Pane key={index} eventKey={index}>
                    {item}
                  </Tab.Pane>
                );
              })}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

function TabSection() {
  return (
    <>
      <TabsPGSLeft
        tabActive="0"
        tabsTitle={trainingModules.map((x, index) => {
          return {
            id: index,
            title: x.title,
          };
        })}
        tabsContent={trainingModules.map((x) => {
          return <CareersWithUs data={x} />;
        })}
      />
    </>
  );
}

export default Member;
